import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CurrencyLanguageService } from 'src/app/shared/currency-language.service';
import { ProductCardEntry } from './product-card.model';
import { SwiperOptions } from 'swiper';
import {
    DAY_PACKAGE_CATEGORY,
    HOTEL_CATEGORY,
    RESTAURANT_CATEGORY,
    SPA_CATEGORY,
    TRAVEL_CATEGORY,
} from '@app/static-content/menu-routes';

@Component({
    selector: 'md-product-card',
    templateUrl: './product-card.component.html',
    styleUrls: ['./product-card.component.scss'],
})
export class ProductCardComponent implements OnInit {
    @Input() dealEntry: ProductCardEntry;
    @Input() condensed = false;
    @Input() openInNewTab = false;
    @Input() noBanners = false;
    @Output() dealSelected = new EventEmitter<ProductCardEntry>();

    currencySymbol: 'Rs.' | 'EUR';
    locale: 'en-MU' | 'fr-RE';
    href: string;
    showSubtitleInsteadOfPills = true;

    config: SwiperOptions = {
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        spaceBetween: 30,
    };

    constructor(private currencyLanguageService: CurrencyLanguageService) {}

    ngOnInit(): void {
        const { productPath, id, categoryId } = this.dealEntry;
        this.showSubtitleInsteadOfPills =
            categoryId !== HOTEL_CATEGORY &&
            categoryId !== DAY_PACKAGE_CATEGORY;
        this.href = `/deal/${productPath}/${id}`;
        this.currencyLanguageService.getCurrency().subscribe((currency) => {
            this.currencySymbol = currency;
        });
        this.currencyLanguageService
            .getLocaleForCurrency()
            .subscribe((locale) => {
                this.locale = locale;
            });
    }

    cardClicked(e: Event): void {
        if (this.openInNewTab) {
            return;
        }
        e.preventDefault();
        this.dealSelected.emit(this.dealEntry);
    }

    getFirstRowFacilities(): string[] {
        return this.dealEntry.facilityNames.slice(0, 2);
    }

    getSecondRowFacilities(): string[] {
        return this.dealEntry.facilityNames.slice(2, 5);
    }
    getRatingLabel(rating: number): string {
        if (rating < 1) {
            return 'Poor';
        } else if (rating < 2) {
            return 'Fair';
        } else if (rating < 3) {
            return 'Good';
        } else if (rating < 4) {
            return 'Very Good';
        } else {
            return 'Excellent';
        }
    }
}
